module.exports = __webpack_public_path__ + "img/0x393B312C01048b3ed2720bF1B090084C09e408A1.8f6eb287.png";